export class Marca {
    cdMarca: number;
	dtAtz: Date;
	fatorRepMax: number;
	fatorRepMin: number;
	nmMarca: string;
	observacao: string;
	ordemPadraoAgrupamento: number;
}
